import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const RequestVirtualCardViewChunk = React.lazy(() =>
  import('../feature-sets/RequestVirtualCardView').then(
    ({ RequestVirtualCardView }) => ({
      default: RequestVirtualCardView,
    })
  )
)

export const RequestVirtualCardPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.requestVirtualCardPageTitle)}
      breadcrumbs={[
        {
          link: url('SpendingCardVirtualCardsPage', {
            tab: 'active',
          }),
          name: intl.formatMessage(messages.virtualCardsPageTitle),
        },
        {
          name: intl.formatMessage(messages.requestVirtualCardPageTitle),
        },
      ]}
    >
      <RequestVirtualCardViewChunk />
    </Page>
  )
}
